import styled from 'styled-components';
import JobActionsOption from './JobActionsOption';
import { colorSchema } from 'utils/style';

export default styled(JobActionsOption)`
  .job-actions-option {
    display: flex;
    align-items: center;
    padding: 0.3rem 1.2rem;
    border: 1px solid ${colorSchema('grey300')};
    margin-top: 0.8rem;

    &__assigned-text,
    &__pending-text {
      font-size: 1.6rem;
      width: 100%;
    }

    &__pending-text {
      color: ${colorSchema('grey500')};
    }

    &__assigned-text {
      color: ${colorSchema('grey900')};
    }

    &__btn {
      padding-right: 0;
      width: auto;
    }

    &__label-wrapper {
      width: 100%;
    }

    &__pending-vehicle {
      color: ${colorSchema('accent900')};
    }
  }
`;
